<template>
  <b-nav-item-dropdown
    ref="dropdown"
    class="chat-button-dropdown mr-25"
    menu-class="dropdown-menu-media mt-50 w-auto"
    title="Диалоги"
    right
  >
    <template #button-content>
      <feather-icon
        icon="MessageSquareIcon"
        size="21"
      ></feather-icon>
    </template>
    <template
      v-if="chatTypes.length"
      v-for="chatType in chatTypes"
    >
      <li
        v-if="chatType.isAvailable"
        class="dropdown-item"
        :title="chatType.title"
        @click="onChatTypeClick(chatType.type)"
      >
        <div class="d-flex align-items-center">
          <template v-if="chatType.customIcon">
            <b-img
              :src="chatType.customIcon"
              :alt="chatType.title"
              class="mr-1"
              :class="chatType.class"
              height="21px"
            ></b-img>
          </template>
          <feather-icon
            v-else
            :icon="chatType.icon"
            size="21"
            class="mr-1"
            :class="chatType.class"
          ></feather-icon>
          <span>{{ chatType.label }}</span>
          <b-badge
            v-if="chatType.isNew"
            class="ml-1 profile-badge"
            variant="light-primary"
          >NEW</b-badge>
        </div>
      </li>
    </template>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BBadge, BImg, BNavItem, BNavItemDropdown,
} from 'bootstrap-vue'
import { inject, ref } from 'vue'
import { openChat } from '@/core/layouts/components/app-navbar/components/chat-button/chat'
import useMimirman from '@/composables/mimirman'
import { getIntegratorId } from '@/composables/currentUser'

export default {
  name: 'ChatButtonDropdown',
  components: {
    BBadge, BImg, BNavItemDropdown, BNavItem
  },
  setup() {
    const { mimirmanLabel, mimirmanLogoSrc } = useMimirman()
    const appConstants = inject('appConstants')
    const dropdown = ref(null)
    const chatTypes = ref([
      {
        title: `${mimirmanLabel} - твой AI-ассистент`, label: mimirmanLabel, type: appConstants.chat.type.MIMIRMAN,
        class: 'text-success mimirman', customIcon: mimirmanLogoSrc, isNew: true, isAvailable: getIntegratorId() === 14
      },
      {
        title: 'Коллеги', icon: 'UsersIcon', label: 'Коллеги', type: appConstants.chat.type.COLLEAGUES,
        class: 'text-primary', isAvailable: true
      },
      {
        title: 'Пациенты', icon: 'UsersIcon', label: 'Пациенты', type: appConstants.chat.type.PATIENTS,
        class: 'text-success', isAvailable: true
      },
    ])

    const onChatTypeClick = type => {
      openChat(type)
      dropdown.value.hide()
    }

    return {
      dropdown,
      chatTypes,

      onChatTypeClick
    }
  }
}
</script>

<style lang='scss' scoped>

body.dark-layout {
  .chat-button-dropdown {
    .mimirman {
      filter: brightness(0) saturate(100%) invert(97%) sepia(3%) saturate(12%) hue-rotate(49deg) brightness(104%) contrast(103%);
    }
  }
}

</style>